import { ApiRequestBody } from 'interfaces/ApiRequestBody';
import RexService from 'services/rexService';

interface SetListingPublishedToPortalRequest extends ApiRequestBody {
  ListingId: string;
  PublishToPortal: boolean;
}

const setListingPublishedToPortal = async (
  requestBody: SetListingPublishedToPortalRequest
): Promise<void> => {
  const { getAuthToken } = requestBody;

  const token = await getAuthToken();
  const service = new RexService(token);

  await service.rexService.post('SetListingPublishedToPortal', requestBody);
};

export default setListingPublishedToPortal;
